import { Trigger } from '@/hooks/useTriggerStream';

export interface WindowResult {
  items: Trigger[];
  /** true when the live window was empty and we fell back to the latest triggers */
  fallback: boolean;
}

/**
 * Live visualizations use very short windows (seconds/minutes). On a quiet
 * network that leaves the canvas empty, so we progressively widen the window
 * and, as a last resort, show the most recent triggers regardless of age.
 */
export function recentOrLatest(
  triggers: Trigger[],
  windowMs: number,
  minCount = 1,
  maxFallback = 60
): WindowResult {
  const now = Date.now();
  const withTs = triggers
    .map((t) => ({ t, ts: new Date(t.created_at).getTime() }))
    .sort((a, b) => b.ts - a.ts);

  // Widen the window up to a week before giving up on real timing.
  for (let w = windowMs; w <= 7 * 24 * 3600 * 1000; w *= 4) {
    const items = withTs.filter((e) => e.ts >= now - w).map((e) => e.t);
    if (items.length >= minCount) {
      return { items, fallback: w !== windowMs };
    }
  }

  return { items: withTs.slice(0, maxFallback).map((e) => e.t), fallback: true };
}
